import React from "react";
import PdfBase from "../../Others/Pdf/PdfBase";
import { generateFaSummaryPdf } from "./generator";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  costRows,
  accDepreciationRows,
  totalOpening,
  totalAdditions,
  totalDisposal,
  totalClosing,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    costRows,
    accDepreciationRows,
    totalOpening,
    totalAdditions,
    totalDisposal,
    totalClosing,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        generatePdf={(forView) => generateFaSummaryPdf(forView, ...sharedArgs)}
        downloadName='Fixed Asset Summary'
        enableDraftView
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateFaSummaryPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
